import { useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';

const Preview = () => {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <Accordion style={{ width: '100%' }}>
      <Accordion.Title
        active={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Icon name="dropdown" />
        미리보기
      </Accordion.Title>
      <Accordion.Content active={!collapsed}>
        <img
          src="/race/응원대회-미리보기1.png"
          alt="응원대회-미리보기1"
          width={240}
        />
        <img
          src="/race/응원대회-미리보기2.png"
          alt="응원대회-미리보기2"
          width={350}
        />
        <img
          src="/race/응원대회-미리보기3.png"
          alt="응원대회-미리보기3"
          width={200}
        />
      </Accordion.Content>
    </Accordion>
  );
};

export default Preview;
